import { render } from "./DetailLink.vue?vue&type=template&id=250290ff"
import script from "./DetailLink.vue?vue&type=script&lang=js"
export * from "./DetailLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__